var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ArticlePage',{attrs:{"isDossier":_vm.isDossier,"module":'TEAM'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }